<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { setWebViewBGColor, setRefreshBtn, startNotify, setConfig } from '@/assistant/JSBridge'
import { isIphoneX } from '@/utils'
export default {
  name: 'app',
  mounted () {
    setConfig()

    let b = '3A4E92'
    setWebViewBGColor(b)

    let params = {
      image: 'http://cdn.hongbaoxd.com/images/5d3cae20b0b4be5958f430120a1a20e2.png',
      size: '{32, 32}',
      top: '36',
      right: '20'
    }
    if (isIphoneX()) {
      params['top'] = '45'
    }
    setRefreshBtn(params)

    startNotify()
  }
}
</script>
<style >
  #app {
    padding-top: 10px;
  }
  @media only screen and (device-height: 812px) {
    #app {
      padding-top: 30px;
    }
  }

</style>
